import {css} from '@emotion/css';
import React, {HTMLAttributes} from 'react';
import {Button} from './Button';
import {theme} from './Common';

export type ModalProps = {
  children: React.ReactNode;
  title?: string;
  isOpen: boolean;
  setModal: (value: boolean) => unknown;
};

export const Modal = ({children, title, isOpen = true, setModal}: ModalProps) => (
  <Container isOpen={isOpen} aria-label='modal' aria-hidden={!isOpen}>
    <CloseModal role='button' aria-label='close modal' onClick={() => setModal(false)} />
    <ModalContent>
      <Button
        buttonStyle='close'
        onClick={() => setModal(false)}
        className={css({position: 'absolute', right: '-26px', top: '-26px'})}
      />
      <TitleContainer>{title}</TitleContainer>
      <BodyContainer>{children}</BodyContainer>
    </ModalContent>
  </Container>
);
const Container = ({isOpen, ...rest}: {isOpen?: boolean} & HTMLAttributes<HTMLDivElement>) => (
  <div
    className={css({
      position: 'fixed',
      width: '100%',
      height: '100%',
      top: 0,
      left: 0,
      background: 'rgba(0, 0, 0, 0.2)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1001,
      transition: 'opacity 0.3s ease-in-out',
      opacity: isOpen ? 1 : 0,
      pointerEvents: isOpen ? 'all' : 'none',
    })}
    {...rest}
  />
);
const CloseModal = (args: HTMLAttributes<HTMLDivElement>) => (
  <div
    className={css({
      position: 'absolute',
      left: 0,
      top: 0,
      cursor: 'pointer',
      width: '100%',
      height: '100%',
      textAlign: 'right',
    })}
    {...args}
  />
);
const ModalContent = (args: HTMLAttributes<HTMLDivElement>) => (
  <div
    className={css({
      background: theme.colors.white,
      maxWidth: '800px',
      minHeight: '200px',
      position: 'relative',
      [theme.mediaMaxWidth.medium]: {padding: `${theme.spacings.small} ${theme.spacings.xsmall}`},
      [theme.mediaMaxWidth.small]: {
        maxWidth: '360px',
        padding: `${theme.spacings.xsmall} ${theme.spacings.xxsmall}`,
      },
    })}
    {...args}
  />
);
const TitleContainer = (args: HTMLAttributes<HTMLDivElement>) => (
  <div
    className={css({
      color: theme.colors.darkBlue,
      fontFamily: theme.font.family,
      fontWeight: theme.font.medium,
      fontSize: theme.font.sizes.medium,
      textAlign: 'left',
      width: '100%',
      borderBottom: `1px solid ${theme.colors.lightBlue}`,
      padding: theme.spacings.large,
      [theme.mediaMaxWidth.small]: {padding: theme.spacings.xsmall},
    })}
    {...args}
  />
);
const BodyContainer = (args: HTMLAttributes<HTMLDivElement>) => (
  <div
    className={css({
      width: '100%',
      maxHeight: '600px',
      padding: theme.spacings.large,
      [theme.mediaMaxWidth.small]: {padding: theme.spacings.medium},
    })}
    {...args}
  />
);
